module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(11).d38c972f.png";